import { useContext } from 'react'
import { LoginContext } from '../context/LoginContext'

export const useLoginValue = () => {
  const value = useContext(LoginContext)
  return value
}
